import React, { ComponentType } from 'react';

import { AddressesProvider } from '../contexts/AddressesProvider';

interface AddressesRouteWrapperProps {
  component: ComponentType<Record<string, unknown>>;
  routeProps?: Record<string, unknown>;
}

const AddressesRouteWrapper: React.FC<AddressesRouteWrapperProps> = ({
  component: Component,
  routeProps,
  ...rest
}) => {
  return (
    <AddressesProvider>
      <Component {...routeProps} {...rest} />
    </AddressesProvider>
  );
};

export default AddressesRouteWrapper;
